import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1eb23146&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1eb23146&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb23146",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eb23146')) {
      api.createRecord('1eb23146', component.options)
    } else {
      api.reload('1eb23146', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1eb23146&scoped=true", function () {
      api.rerender('1eb23146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/publishTips/index.vue"
export default component.exports